import React from 'react';
import { SizeMe } from 'react-sizeme';

const KeepAspectRatio = ({ adjustAcordingToWidth, children }) => {
  return (
    <SizeMe
      monitorWidth={adjustAcordingToWidth}
      monitorHeight={!adjustAcordingToWidth}
    >
      {({ size }) =>
        <div style={{
          height: !adjustAcordingToWidth ? "100%" : size.width * 0.5625,
          width: adjustAcordingToWidth ? "100%" : size.height * 1.78
        }}>{children}</div>
      }
    </SizeMe>
  );
};

export default KeepAspectRatio;